import { enTranslation } from './en.translation';

export const commonTranslationConfig = {
  en: enTranslation,
};
